import axios from 'axios';
import { LOCALFORAGE_YN, SERVER_URL } from '../../../common/comstant/CommonConstants';
import { useInvestmentIncomeStore } from '../store/InvestmentIncome.localforage';
import {
  InvestmentIncome,
  InvestmentIncomeRequest,
} from '../type/InvestmentIncome.type';

export const useInvestmentIncomeAPI = () => {
  const {
    insertInvestmentIncomeToStore,
    getInvestmentIncomeListFromStore,
    updateInvestmentIncomeAtStore,
    deleteInvestmentIncomeAtStore,
  } = useInvestmentIncomeStore();

  const insertInvestmentIncome = async (request: InvestmentIncomeRequest) =>
    LOCALFORAGE_YN
      ? insertInvestmentIncomeToStore(request)
      : axios.post<string>(`${SERVER_URL}/investment-income`, request);

  const getInvestmentIncomeList = async () =>
    LOCALFORAGE_YN
      ? getInvestmentIncomeListFromStore()
      : axios.get<InvestmentIncome[]>(`${SERVER_URL}/investment-income`);

  const updateInvestmentIncome = async (id: string, request: InvestmentIncomeRequest) =>
    LOCALFORAGE_YN
      ? updateInvestmentIncomeAtStore(id, request)
      : axios.put<string>(`${SERVER_URL}/investment-income/${id}`, request);

  const deleteInvestmentIncome = async (id: string) =>
    LOCALFORAGE_YN
      ? deleteInvestmentIncomeAtStore(id)
      : axios.delete<InvestmentIncome>(`${SERVER_URL}/investment-income/${id}`);

  return {
    insertInvestmentIncome,
    getInvestmentIncomeList,
    updateInvestmentIncome,
    deleteInvestmentIncome,
  };
};
